export const getFirstSupportedLanguage = (preferredLanguages, supportedLanguages) => {
  const language = Array.isArray(preferredLanguages)
    ? preferredLanguages.find(lang => supportedLanguages.includes(lang))
    : preferredLanguages;
  return language ? language : supportedLanguages.length ? supportedLanguages[0] : undefined;
};
